import { render, staticRenderFns } from "./MeasurementItem.vue?vue&type=template&id=7c59cc77&scoped=true&"
import script from "./MeasurementItem.vue?vue&type=script&lang=js&"
export * from "./MeasurementItem.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementItem.vue?vue&type=style&index=0&id=7c59cc77&prod&lang=scss&scoped=true&"
import style1 from "./MeasurementItem.vue?vue&type=style&index=1&id=7c59cc77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c59cc77",
  null
  
)

export default component.exports